import Glider from 'glider-js';

export const init = () => {
	const jsTestimonialsCarousel = document.querySelectorAll('.js-testimonials-carousel');

	Array.from(jsTestimonialsCarousel).forEach((item) => {
		const prevControl = item.nextElementSibling.querySelector('.slider-control__arrow-prev');
		const nextControl = item.nextElementSibling.querySelector('.slider-control__arrow-next');

		new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: false,
			duration: 0.3,
			arrows: {
				prev: prevControl,
				next: nextControl,
			},
		});

		if (item.querySelectorAll('.testimonials__item').length < 2) {
			item.parentElement.querySelector('.slider-control').classList.add('u-hide');
			item.parentElement.classList.add('testimonials__carousel-wrap--no-controls');
		}
	});
};
